import { useTranslation } from 'react-i18next';

export default function CtaSection() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="relative w-full max-w-3xl mx-auto mb-10 rounded-2xl overflow-hidden" style={{ aspectRatio: '16/7' }}>
          <img
            src="https://readdy.ai/api/search-image?query=Aesthetic%20minimalist%20fashion%20flatlay%20with%20cream%20toned%20clothing%20sneakers%20accessories%20and%20a%20laptop%20displaying%20spreadsheet%20on%20warm%20neutral%20textured%20surface%2C%20soft%20natural%20window%20lighting%2C%20editorial%20photography%20with%20film%20grain%20texture%2C%20cozy%20and%20inviting%20atmosphere%2C%20organic%20composition%20with%20warm%20undertones&width=1200&height=525&seq=cta-visual-main-v2-y3z4&orientation=landscape"
            alt="HoobuySpreadsheet"
            className="w-full h-full object-cover object-top"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
        </div>

        <p className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-900 leading-tight mb-4">
          {t('cta.title')}{' '}
          <span className="italic font-normal text-foreground-500">{t('cta.highlight')}</span>
          {' '}{t('cta.titleEnd')}
        </p>

        <p className="text-sm md:text-base text-foreground-500 mb-8 max-w-lg mx-auto">
          {t('cta.description')}
        </p>

        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-2 px-10 py-4 text-sm font-semibold bg-foreground-900 text-background-50 rounded-full hover:bg-foreground-800 transition-all whitespace-nowrap cursor-pointer shadow-lg shadow-foreground-900/10"
        >
          {t('cta.button')}
          <i className="ri-arrow-right-up-line"></i>
        </a>
      </div>
    </section>
  );
}